import { Modal } from "@monolith-forensics/monolith-ui";
import {
  ConvertInquiryForm,
  ConvertInquiryFormData,
  MergeInquiryFormData,
} from "../Forms";

interface ConvertInquiryModalProps {
  show: boolean;
  inquiry: {
    inquiry_id: number;
    inquiry_case_num: string;
    request_name: string;
    inquiry_type: string;
  };
  defaultFormData?: Partial<ConvertInquiryFormData>;
  onClose: () => void;
  onSubmit: () => void;
  onCancel?: () => void;
}

export const ConvertInquiryModal: React.FC<ConvertInquiryModalProps> = ({
  show,
  inquiry,
  defaultFormData,
  onClose,
  onSubmit,
  onCancel,
}) => {
  const handleSubmit = () => {
    onSubmit?.();
    onClose();
  };

  const handleCancel = () => {
    onCancel?.();
    onClose();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <ConvertInquiryForm
        inquiry={inquiry}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        defaultFormData={{
          case_type: inquiry?.inquiry_type,
          ...defaultFormData,
        }}
      />
    </Modal>
  );
};
